import { CountryConfigType } from '../../model/CountryConfigType'

const config: CountryConfigType = {
  showQuoteSummaryAgreementNotice: true,
}

export default config
